import React from "react";
import {DropdownItem, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown} from "reactstrap";

const DropdownButtonComponent = ({items, style, datacy}) => {
    return (
        <UncontrolledButtonDropdown className="pathway-dropdown-button" style={style}>
            <DropdownToggle data-cy={datacy} color="white" size="sm" style={{boxShadow: "none"}}>
                <i className="fas fa-ellipsis-h"></i>
            </DropdownToggle>
            <DropdownMenu>
                {items.map((entry, index) => {
                    if (entry === null) {
                        return <DropdownItem key={index} style={{margin: "0"}} divider/>;
                    } else {
                        return (
                            <DropdownItem
                                style={{border: "none"}}
                                key={index}
                                disabled={entry[2]}
                                onClick={entry[1]}
                            >
                                {entry[0]}
                            </DropdownItem>
                        );
                    }
                })}
            </DropdownMenu>
        </UncontrolledButtonDropdown>
    );
}

export default DropdownButtonComponent;
